var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import actions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import "../BankSelector/BankSelector.scss";
// helpers
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
import OtcDi from "../../../../mainDi/features/OTC/servicelocator";
import Loader from "@frameworks/shared-library/components/Loader";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
var RefundSearch = function (_a) {
    var _b, _c, _d, _e, _f;
    var searchRef = useRef(null);
    var searchInputRef = useRef(null);
    var popupRef = useRef(null);
    var cActions = new actions();
    var _g = __read(useState(""), 2), searchText = _g[0], setSearchText = _g[1];
    var _h = __read(useState(false), 2), isSearchFocused = _h[0], setIsSearchFocused = _h[1];
    var _j = __read(useState(false), 2), loading = _j[0], setLoading = _j[1];
    var _k = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }), clientPanData = _k.clientPanData, suspenseFormData = _k.suspenseFormData;
    var handleOnchangeSearch = function (e) {
        var inputValue = e.target.value;
        setSearchText(inputValue);
        debounce(function () { return getClientPan(inputValue); });
    };
    var getClientPan = function (searchText) {
        setLoading(true);
        OtcDi.orderBook
            .getClientPan({
            search_txt: searchText,
        })
            .then(function (response) {
            setLoading(false);
        })
            .catch(function (error) {
            setLoading(false);
        });
    };
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (popupRef.current &&
                !popupRef.current.contains(event.target) &&
                searchRef.current &&
                !searchRef.current.contains(event.target)) {
                setIsSearchFocused(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var onClearSearch = function () {
        var _a;
        setSearchText("");
        (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        getClientPan("");
        cActions.setSuspenseForm(__assign(__assign({}, suspenseFormData), { clientPan: {
                order_id: 0,
                sell_reference_no: "",
                acc_code: "",
                client_name: "",
                pan: "",
            } }));
    };
    var onClickSelectItem = function (item) {
        setSearchText("".concat(item.pan, "-").concat(item.client_name));
        setIsSearchFocused(false);
        cActions.setSuspenseForm(__assign(__assign({}, suspenseFormData), { clientPan: item }));
    };
    useEffect(function () {
        getClientPan("");
    }, []);
    return (React.createElement("div", { className: "position-relative otc-bank-selection" },
        React.createElement("label", { className: "txt_blackOne DMSanN_14_400 mb-2 ms-1" }, "Client PAN"),
        React.createElement(Form, { style: { paddingBlock: 7 }, className: "common-search ".concat(false ? "border-danger" : isSearchFocused && "active-input", " d-flex align-items-center position-relative"), ref: searchRef },
            React.createElement("div", { className: "search-input-icons-container d-flex align-items-center w-100" },
                React.createElement("div", { className: "search_icon_ap", style: { marginTop: "3px", marginRight: "5px" } },
                    React.createElement("i", { className: "edel-icon-search" })),
                React.createElement("input", { className: "DMSanN_14_400 txt_blue-tint d-flex bg-transparent w-100", type: "search", value: searchText, placeholder: "Search Client PAN..", "aria-label": "Search", onChange: handleOnchangeSearch, onFocus: function () { return setIsSearchFocused(true); }, ref: searchInputRef }),
                isSearchFocused && searchText ? (React.createElement("span", { className: "edel-icon-close cross-icon hand_cursor", onClick: onClearSearch })) : (React.createElement(React.Fragment, null)))),
        isSearchFocused && (React.createElement("div", { style: { paddingRight: "6px" } },
            React.createElement("div", { ref: popupRef, className: "client-popup-emp-search header px-0 position-absolute bg_white overflow-x-hidden d-flex flex-column" }, loading ? (React.createElement("div", { className: "mt-5 mb-5" },
                React.createElement(Loader, null))) : (React.createElement("div", null,
                ((_b = clientPanData === null || clientPanData === void 0 ? void 0 : clientPanData.data) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement("p", { className: "DMSans_13_500 not-found mx-2" }, "".concat((_c = clientPanData === null || clientPanData === void 0 ? void 0 : clientPanData.data) === null || _c === void 0 ? void 0 : _c.length, " ").concat(((_d = clientPanData === null || clientPanData === void 0 ? void 0 : clientPanData.data) === null || _d === void 0 ? void 0 : _d.length) > 1 ? "results" : "result", " found"))),
                ((_e = clientPanData === null || clientPanData === void 0 ? void 0 : clientPanData.data) === null || _e === void 0 ? void 0 : _e.length) > 0 ? ((_f = clientPanData === null || clientPanData === void 0 ? void 0 : clientPanData.data) === null || _f === void 0 ? void 0 : _f.map(function (item, index) {
                    return (React.createElement("div", { className: "bank-logo-container DMSanN_14_400 hand_cursor", onClick: function () {
                            onClickSelectItem(item);
                        }, key: "".concat(item.client_name, "-").concat(index) },
                        React.createElement(GenericSchemeName, { name: item.client_name, subText1: item.pan, maxWidth: 200, showTooltip: false, showImage: true, image: "", clickHandlerConfig: {
                                schemeNameClickConfig: {
                                    className: "bank-name",
                                },
                            } })));
                })) : (React.createElement("p", { className: "DMSans_13_500 not-found mx-2" }, "No result found")))))))));
};
export default RefundSearch;
